export default function Support() {
  return (
    <div className="bg-white text-slate-900">
      <div className="mx-auto max-w-4xl px-4 py-10 lg:py-16">
        <h1 className="text-3xl font-bold text-slate-900">Happy Tail Tracker Support</h1>
        <p className="mt-2 text-sm text-slate-600">
          We are here to help with anything from sign-in issues to questions about tracking your pet&apos;s health.
        </p>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">How to reach us</h2>
          <p className="leading-relaxed text-slate-800">
            Email <a href="mailto:support@happytailtracker.com" className="text-blue-600 underline">support@happytailtracker.com</a>{' '}
            with a short description of the issue, the email on your account, and any screenshots that help us reproduce
            the problem. We typically respond within one business day.
          </p>
        </section>

        <section className="mt-8 space-y-4">
          <h2 className="text-2xl font-semibold text-slate-900">What to include</h2>
          <ul className="list-disc space-y-2 pl-6 text-slate-800">
            <li>Which platform you are using (iOS, Android, or web).</li>
            <li>The steps you took before the issue appeared and any error message you saw.</li>
            <li>Your device model and OS version if you are on mobile.</li>
          </ul>
          <p className="text-slate-800">
            Sharing these details helps us investigate quickly and get you back to caring for your pets.
          </p>
        </section>
      </div>
    </div>
  );
}
